export const FETCH_LISTS_REQUEST = 'FETCH_LISTS_REQUEST';
export const FETCH_LISTS_SUCCESS = 'FETCH_LISTS_SUCCESS';
export const FETCH_LIST_PAGINATION_SUCCESS = 'FETCH_LIST_PAGINATION_SUCCESS';
export const FETCH_ALL_LISTS = 'FETCH_ALL_LISTS';
export const LIST_ENRICHMENT_STARTED = 'LIST_ENRICHMENT_STARTED';
export const LIST_ENRICHMENT_FINISHED = 'LIST_ENRICHMENT_FINISHED';
export const FETCH_LISTS_FOR_DROPDOWNS = 'FETCH_LISTS_FOR_DROPDOWNS';
export const FETCH_LISTS_WITH_ACTIVE_PROFILES = 'FETCH_LISTS_WITH_ACTIVE_PROFILES';
export const FETCH_ACTIVE_PROFILES_COUNT = 'FETCH_ACTIVE_PROFILES_COUNT';
